import { getList, GetListPayload, GetListResponse } from 'services/quotation-pending-approval'
import useAppQuery, { AppQueryOptions } from 'hooks/use-app-query'
import { pendingQuotationApprovalListKey } from 'utils/constants/queryKey'

const useQuotationPendingApprovalList = (payload: GetListPayload, options?: AppQueryOptions<GetListResponse>) =>
  useAppQuery(pendingQuotationApprovalListKey.list(payload), () => getList(payload), options)

export { useQuotationPendingApprovalList }
